import cloneDeep from 'lodash/cloneDeep';

const formatPositionDetail = (data) => {
  if (!data) {
    return data;
  }
  let cloneData = cloneDeep(data);
  const officeCitys = cloneData?.office?.map((item) => item?.name)?.join(',');
  cloneData = {
    ...cloneData,
    officeCitys,
  };
  return cloneData;
};

export default formatPositionDetail;
